import settingsConfig from 'CampaignBuilder/settingsConfig'
import SettingsSchemaForm from 'Shared/components/Settings/SettingsSchemaForm'

export default function SettingsForm() {
  const act = useAct()
  const { settings, campaignType } = useSel((s) => s.campaign)

  const config = settingsConfig[campaignType]

  const onChange = (key, value) => {
    act.campaign.updateSetting(key, value)
  }

  return <SettingsSchemaForm onChange={onChange} settings={settings} config={config} />
}
